import "./UnfoundPage.css";
import { Typography } from "@mui/material";

function UnfoundPage() {
  return (
    <div className="UnfoundPage__container">
      <Typography
        variant="h4"
        sx={{
          color: "primary.main",
          textAlign: "center",
          marginTop: "20px",
          fontWeight: "bold",
        }}
      >
        Oops...
      </Typography>
      <Typography
        variant="body1"
        sx={{ color: "primary.main", textAlign: "center", fontWeight: "bold" }}
      >
        The page you are looking for does not exist at the moment.
      </Typography>
    </div>
  );
}

export default UnfoundPage;
